import React from "react";

import { AssetGalleryManager } from "components/admin";
import { useAuth } from "context/auth-context";
import { workspaceApi } from "pages/app/workspace/services";
import { SchoolPlayerProfileTabProps } from "pages/app/workspace/school-player-profile/school-player-profile.types";
import { hasAnyPortalAction } from "utils/portal-access";

export const SchoolPlayerMediaTab: React.FC<SchoolPlayerProfileTabProps> = ({
  athlete,
  athleteLoading,
  playerId,
  schoolId,
}) => {
  const { portalAccess } = useAuth();

  const canManagePlayerGallery = hasAnyPortalAction(portalAccess, [
    "player_gallery.manage",
    "school_players.update",
    "school_players.manage",
  ]);

  const galleryInvalidateKeys = [
    ["school-player-profile-athlete", playerId],
    ["workspace-school-players", schoolId],
    ["athlete", playerId],
  ].filter((queryKey) => Boolean(queryKey[1]));

  return (
    <AssetGalleryManager
      canManage={canManagePlayerGallery && Boolean(playerId)}
      createLabel="Add player asset"
      emptyDescription="No player gallery items have been added yet."
      invalidateKeys={galleryInvalidateKeys}
      isLoading={athleteLoading}
      items={athlete?.gallery_items || []}
      onCreate={(payload) => workspaceApi.galleryItems.createPlayer(playerId, payload)}
      onRemove={(item) => workspaceApi.galleryItems.remove(String(item.id))}
      onUpdate={(item, payload) => workspaceApi.galleryItems.update(String(item.id), payload)}
      subtitle="Keep scouting visuals, posters, clips, and player media attached directly to this school player."
      title="Gallery"
    />
  );
};
